import { Link } from 'react-router-dom';

export default function HomeCtaBanner() {
  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5c6d1c65b87fcaee36863819e4007ff5.jpg"
          alt="Florida neighborhood"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/80 to-stone-900/50"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-xl">
          <p className="text-amber-400 text-xs font-semibold tracking-widest uppercase mb-4">Ready to Get Started?</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
            Let&apos;s Find Your Perfect Florida Home
          </h2>
          <p className="text-white/75 text-base leading-relaxed mb-10">
            Whether you&apos;re buying, selling, or just exploring, Amparo Jarquin is here to guide you every step of the way.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/request"
              className="px-8 py-4 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm tracking-wide text-center"
            >
              Request More Information
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 border-2 border-white/60 hover:border-white text-white font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm tracking-wide text-center"
            >
              Contact Amparo
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
